// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.EnhanceContext.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import HTML5Backend from 'react-dnd-html5-backend';
import AppContext from './Izenda.AppContext';
import { DragDropContext } from 'react-dnd';
import { compose } from 'recompose';
import BrowserUtils from 'share/utils/Izenda.BrowserUtils';

const ModifiedBackend = (...args) => {
  const instance = new HTML5Backend(...args);

  // Fix Chrome not sending a DragEnd after Drop, which other browsers do and react-dnd expects
  const originalEndDragIfSourceWasRemovedFromDOM = instance.endDragIfSourceWasRemovedFromDOM;
  instance.endDragIfSourceWasRemovedFromDOM = (e, ...args) => {
    if (BrowserUtils.isChromeBrowser() && instance.clearCurrentDragSourceNode()) {
      instance.actions.endDrag();
    }
    originalEndDragIfSourceWasRemovedFromDOM(e, ...args);
  };

  return instance;
};

const enhanceContext = (WrappedComponent: any) => {
  return class extends Component {
    static childContextTypes = {
      dialogs: PropTypes.object,
      validation: PropTypes.object.isRequired,
      loader: PropTypes.object.isRequired,
      authorization: PropTypes.object.isRequired,
      authorizationConstants: PropTypes.object.isRequired,
      localization: PropTypes.object.isRequired,
      exportLoader: PropTypes.object.isRequired
    };

    izendaContext: null;

    getChildContext() {
      !this.izendaContext && (this.izendaContext = AppContext.createAppContext());
      return this.izendaContext;
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  };
};

export default compose(DragDropContext(ModifiedBackend), enhanceContext);



// WEBPACK FOOTER //
// ./ui/share/enhancers/Izenda.EnhanceContext.js